<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>服务管理</el-breadcrumb-item>
      <el-breadcrumb-item>新请求</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="80px"
        >
          <el-form-item
            label="中间商"
            prop="filter_dealer_id"
            v-if="!isadealer"
          >
            <dealer-select
              :val="filter.filter_dealer_id"
              @change="filter.filter_dealer_id = $event"
            ></dealer-select>
          </el-form-item>
          <el-form-item label="客户" prop="customer_id">
            <customer-select
              :val="filter.customer_id"
              @change="filter.customer_id = $event"
            ></customer-select>
          </el-form-item>
          <el-form-item label="客户行业" prop="industry">
            <el-cascader
              size="small"
              v-model="filter.industries"
              :options="DeviceApplicationOptions"
              :props="{ multiple: true }"
              collapse-tags
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item label="NCR编号" prop="number">
            <el-input
              size="small"
              v-model="filter.number"
              @keyup.enter.native="requestServiceQuest"
              autocomplete="off"
              placeholder="搜索NCR编号、业务机会编号"
            ></el-input>
          </el-form-item>
          <template v-if="filterShow || !isMobile()">
            <el-form-item
              label="ServiceOrder"
              prop="service_order_number"
              v-if="category == 1 && !canNew"
            >
              <el-input
                size="small"
                v-model="filter.service_order_number"
                @keyup.enter.native="requestServiceQuest"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="设备分类" prop="item_category_id">
              <item-category-select
                :val="filter.item_category_id"
                :category="2"
                @change="filter.item_category_id = $event"
              ></item-category-select>
            </el-form-item>
            <el-form-item label="设备机型" prop="machine_type">
              <el-input
                size="small"
                v-model="filter.machine_type"
                @keyup.enter.native="requestServiceQuest"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="序列号" prop="serial_number">
              <el-input
                size="small"
                v-model="filter.serial_number"
                @keyup.enter.native="requestServiceQuest"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="生产工厂" prop="factory" v-if="!canNew">
              <el-select
                size="small"
                v-model="filter.factory"
                style="width: 100%"
                placeholder="请选择"
              >
                <el-option value="" label="不限"></el-option>
                <el-option key="TJ" label="TJ" value="TJ"> </el-option>
                <el-option key="KN" label="KN" value="KN"> </el-option>
                <el-option key="QD" label="QD" value="QD"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="问题分类">
              <el-select
                v-model="filter.problem"
                placeholder="请选择"
                size="small"
                filterable
                clearable
              >
                <el-option key="" label="不限" value=""></el-option>
                <el-option
                  v-for="(item, index) in cmm_categories"
                  :key="index"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="是否保修内"
              prop="in_repair_scope"
              v-if="!canNew"
            >
              <el-select
                size="small"
                v-model="filter.in_repair_scope"
                style="width: 100%"
                placeholder="请选择"
              >
                <el-option :value="0" label="不限"></el-option>
                <el-option :value="1" label="是"></el-option>
                <el-option :value="2" label="否"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否给保" prop="give_insurance" v-if="!canNew">
              <el-select
                size="small"
                v-model="filter.give_insurance"
                style="width: 100%"
                placeholder="请选择"
              >
                <el-option :value="0" label="不限"></el-option>
                <el-option :value="1" label="是"></el-option>
                <el-option :value="2" label="否"></el-option>
              </el-select>
            </el-form-item>
            <template v-if="!isadealer && !canNew">
              <el-form-item label="HS2" prop="hs2_status">
                <el-select
                  size="small"
                  v-model="filter.hs2_status"
                  style="width: 100%"
                  placeholder="请选择"
                >
                  <el-option :value="0" label="不限"></el-option>
                  <el-option :value="1" label="已填写"></el-option>
                  <el-option :value="2" label="未填写"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="物流" prop="logistics_status">
                <el-select
                  size="small"
                  v-model="filter.logistics_status"
                  style="width: 100%"
                  placeholder="请选择"
                >
                  <el-option :value="0" label="不限"></el-option>
                  <el-option :value="1" label="已填写"></el-option>
                  <el-option :value="2" label="未填写"></el-option>
                </el-select>
              </el-form-item>
            </template>
            <el-form-item label="发起人" prop="initiator" v-if="!isadealer">
              <user-select
                size="small"
                :allResource="true"
                :allowCreate="true"
                :val="filter.initiator"
                @change="filter.initiator = $event"
              ></user-select>
            </el-form-item>
            <el-form-item
              label="负责人"
              prop="director_id"
              v-if="category == 1 && !canNew && !isadealer"
            >
              <user-select
                size="small"
                :allResource="true"
                :val="filter.director_id"
                @change="filter.director_id = $event"
              ></user-select>
            </el-form-item>
            <el-form-item label="紧急程度" prop="level">
              <el-select
                size="small"
                v-model="filter.level"
                style="width: 100%"
                placeholder="请选择"
              >
                <el-option :value="0" label="所有"></el-option>
                <el-option
                  v-for="(label, value) in ServiceQuestLevelMap"
                  :key="value"
                  :label="label"
                  :value="parseInt(value)"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订单状态" v-if="isFilterStatuses">
              <el-select
                collapse-tags
                size="small"
                v-model="filter.statuses"
                @change="statusChange"
                multiple
                style="width: 100%"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in statusOptions"
                  :key="item.val"
                  :value="item.val"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否超时" prop="over_time">
              <el-select
                size="small"
                v-model="filter.over_time"
                style="width: 100%"
                placeholder="请选择"
              >
                <el-option :value="0" label="不限"></el-option>
                <el-option :value="1" label="已超时"></el-option>
                <el-option :value="2" label="未超时"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="日期" prop="date">
              <el-date-picker
                style="width: 360px"
                v-model="filter.date"
                type="daterange"
                size="small"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :unlink-panels="true"
              ></el-date-picker>
            </el-form-item>
            <el-divider v-if="category == 1 && !canNew"></el-divider>
            <el-form-item label="流程（旧）" v-if="category == 1 && !canNew">
              <el-select
                v-model="filter.mode"
                placeholder="请选择"
                size="small"
              >
                <el-option :key="0" label="不限" :value="0"></el-option>
                <el-option-group key="group1" label="保内">
                  <el-option
                    :key="11"
                    label="保内现场维修"
                    :value="11"
                  ></el-option>
                  <el-option
                    :key="2"
                    label="保内寄回STC"
                    :value="2"
                  ></el-option>
                  <el-option
                    :key="1"
                    label="保内维修点维修"
                    :value="1"
                  ></el-option>
                </el-option-group>
                <el-option-group key="group2" label="保外">
                  <el-option
                    :key="7"
                    label="保外现场维修"
                    :value="7"
                  ></el-option>
                  <el-option
                    :key="8"
                    label="保外寄回STC"
                    :value="8"
                  ></el-option>
                  <el-option
                    :key="12"
                    label="保外维修点维修"
                    :value="12"
                  ></el-option>
                </el-option-group>
                <el-option-group key="group3" label="其他">
                  <el-option :key="13" label="返回PC" :value="13"></el-option>
                  <el-option :key="3" label="销售跟进" :value="3"></el-option>
                  <el-option
                    :key="4"
                    label="海外维修/检查"
                    :value="4"
                  ></el-option>
                  <el-option
                    :key="9"
                    label="收费维修（海外）"
                    :value="9"
                  ></el-option>
                  <el-option :key="5" label="本地处理" :value="5"></el-option>
                  <el-option :key="6" label="转CDC" :value="6"></el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="流程状态" v-if="category == 1 && !canNew">
              <el-select
                size="small"
                v-model="filter.mode_status"
                style="width: 100%"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in modeStatusOptions"
                  :key="item.val"
                  :value="item.val"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
            <div style="width: 100%" v-if="category == 1 && !canNew"></div>
            <!-- <el-divider class=""></el-divider> -->
            <el-form-item label="流程（新）" v-if="category == 1 && !canNew">
              <ServiceQuestFlowSelect
                v-model="filter.service_quest_flow_id"
                :search="true"
              ></ServiceQuestFlowSelect>
            </el-form-item>
            <el-form-item label="流程状态" v-if="category == 1 && !canNew">
              <FlowStepSelector
                v-model="filter.step_ids"
                :flow-id="filter.service_quest_flow_id"
              ></FlowStepSelector>
            </el-form-item>
            <el-divider v-if="category == 1 && !canNew"></el-divider>
            <el-form-item label="排序方式">
              <el-select
                size="small"
                v-model="filter.order_arr"
                multiple
                clearable
                style="width: 540px"
                placeholder="可多选"
                class="mul-long"
              >
                <el-option
                  v-for="item in OrderOptions"
                  :key="item.val"
                  :value="item.val"
                  :label="item.label"
                ></el-option>
              </el-select>
              <div
                class="font-12 text-info"
                style="line-height: 1.4em; margin-top: 4px"
              >
                选择时，先选的会排在前面；选中多个选项时，搜索结果会按选择框中排序项的先后顺序进行排序
              </div>
            </el-form-item>
          </template>
        </el-form>
        <div class="mt-10 flex-row-between">
          <div>
            <el-button
              type="primary"
              size="small"
              @click="requestServiceQuest()"
              >筛选</el-button
            >
            <el-button size="small" @click="reset()">重置</el-button>
          </div>
          <div
            class="flex-row-base"
            v-if="isMobile()"
            @click="
              filterShow = !filterShow
              scrollToTop()
            "
          >
            <i
              class="text-gray"
              :class="filterShow ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
            ></i>
            <span class="text-info-12">
              {{ filterShow ? '隐藏高级筛选' : '展开高级筛选' }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <div class="header">
        <el-button
          v-if="canNew"
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="startServiceQuestFormer"
          v-permission="Auth.serviceQuestCreate"
          >新请求</el-button
        >
        <div style="display: flex; float: right">
          <file-button
            v-if="isFilterStatuses"
            v-permission="Auth.serviceQuestIE"
            obj="service_quest_flow_all"
            :filter="queryData"
            exportBtnName="导出源数据"
            :importButton="false"
            class="mobile-hide mr-10"
          ></file-button>
          <file-button
            v-if="isFilterStatuses"
            v-permission="Auth.serviceQuestIE"
            obj="service_quest_all"
            :filter="queryData"
            exportBtnName="导出汇总表"
            :importButton="false"
            class="mobile-hide mr-10"
          ></file-button>
          <file-button
            v-if="isFilterStatuses"
            v-permission="Auth.serviceQuestIE"
            obj="service_quest_flow"
            :filter="queryData"
            exportBtnName="导出流程进度明细"
            :importButton="false"
            class="mobile-hide mr-10"
          ></file-button>

          <file-button
            v-permission="Auth.serviceQuestIE"
            obj="service_quest"
            :filter="queryData"
            :importButton="false"
            class="mobile-hide"
          ></file-button>
        </div>
      </div>
      <el-table :data="serviceQuests" v-loading="loading" size="mini">
        <el-table-column label="NCR/SO" width="120px">
          <template slot-scope="scope">
            <service-quest-link
              :id="scope.row.id"
              :number="scope.row.number"
            ></service-quest-link>
            <div class="text-gray">{{ scope.row.service_order_number }}</div>
          </template>
        </el-table-column>
        <el-table-column label="客户" v-if="isadealer">
          <template slot-scope="scope"
            >{{ scope.row.customer.name
            }}<el-tag
              size="mini"
              type="danger"
              class="ml-5"
              v-if="
                scope.row.category == 1 && scope.row.customer.important == 2
              "
              >紧急</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="客户/中间商" min-width="160" v-else>
          <template slot-scope="scope"
            >{{ scope.row.customer.name
            }}<el-tag
              size="mini"
              type="danger"
              class="ml-5"
              v-if="
                scope.row.category == 1 && scope.row.customer.important == 2
              "
              >紧急</el-tag
            >
            <br />
            <div class="text-gray" v-if="scope.row.dealer.name">
              {{ scope.row.dealer.name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="设备/设备描述/问题分类" min-width="200">
          <template slot-scope="scope">
            <div>
              {{ scope.row.device.serial_number
              }}<span v-if="scope.row.device.equipment_number"
                >（{{ scope.row.device.equipment_number }}）</span
              >
            </div>
            <div v-if="scope.row.device.description">
              {{ scope.row.device.description }}
            </div>
            {{
              scope.row.sub_category
                ? `${scope.row.cmm_category}（${scope.row.sub_category}）`
                : scope.row.cmm_category
            }}</template
          >
        </el-table-column>
        <!-- <el-table-column
          label="紧急程度"
          v-if="category == 1"
          align="center"
          width="100"
        >
          <template slot-scope="scope">{{
            scope.row.level > 0 ? ServiceQuestLevelMap[scope.row.level] : '-'
          }}</template>
        </el-table-column> -->
        <el-table-column label="当前状态/等待时间" align="center" width="180">
          <template slot-scope="scope">
            <template
              v-if="scope.row.approval_id > 0 && scope.row.approve_index == 0"
            >
              <span class="status-tag-border info">待审批</span>
            </template>
            <template v-else>
              <span v-if="scope.row.status == 2" class="status-tag-border info">
                {{
                  scope.row.is_new_flow
                    ? scope.row.current_step.name
                    : ServiceQuestModeStatus[scope.row.mode_status]
                }}
              </span>
              <span v-else>{{ ServiceQuestStatusMap[scope.row.status] }}</span>
            </template>
            <span
              :class="{ 'text-danger': scope.row.is_over_time }"
              v-if="scope.row.status == 1 || scope.row.status == 2"
            >
              <br />
              {{ scope.row.waited_day }}个工作日<span
                class="font-12"
                v-if="scope.row.is_over_time"
                >(已超时)</span
              >
            </span>
          </template></el-table-column
        >
        <el-table-column label="HS2" align="center" width="60">
          <template slot-scope="scope">
            <span
              class="value-status-dot"
              :class="{ 'has-value': scope.row.hs2 }"
              :title="scope.row.hs2 ? '有' : '无'"
            ></span>
          </template>
        </el-table-column>
        <el-table-column label="物流" align="center" width="60">
          <template slot-scope="scope">
            <span
              class="value-status-dot"
              :class="{ 'has-value': scope.row.logistics_number }"
              :title="scope.row.logistics_number ? '有' : '无'"
            ></span>
          </template>
        </el-table-column>
        <el-table-column label="发起人" align="center" width="90">
          <template slot-scope="scope">{{
            scope.row.user.name || scope.row.customer_user.name
          }}</template>
        </el-table-column>
        <el-table-column label="请求日期" align="center" width="150">
          <template slot-scope="scope">
            <span>
              {{ formatTime(scope.row.created_at, 'YYYY-MM-DD HH:mm') }}
            </span>
          </template></el-table-column
        >
        <el-table-column label="负责人" align="center" width="120">
          <template slot-scope="scope">
            <!-- <template v-if="scope.row.status == 2"> -->
            <!-- <span v-if="scope.row.approval_id > 0">{{ scope.row.approval.name }}</span>
              <span v-else>{{ scope.row.director.name }}</span> -->
            <span>{{ scope.row.director.name }}</span>
            <!-- </template> -->
          </template>
        </el-table-column>
        <el-table-column label="总用时" align="center" width="130">
          <template slot-scope="scope">
            {{ scope.row.total_day }}个工作日
          </template></el-table-column
        >
        <el-table-column label="操作" align="center" width="80" fixed="right">
          <template slot-scope="scope">
            <router-link
              :to="$route.path + '/' + scope.row.id + '?origin=0'"
              v-permission="Auth.serviceQuestDetail"
            >
              <el-button type="primary" size="mini" plain>查看</el-button>
            </router-link>
          </template></el-table-column
        >
      </el-table>
      <div class="mt-20">
        <el-pagination
          class="mt-20"
          :page-size="filter.size"
          :current-page.sync="filter.page"
          layout="total, prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <service-quest-former
      :model="serviceQuestForm"
      :show.sync="addServiceQuestFormVisible"
      @created="createdServiceQuest"
    ></service-quest-former>
  </div>
</template>

<script>
import { serviceQuestList, ccmCategoryList } from '../../service/getData'
import ServiceQuestFormer from '../../components/service_quest'
import { ServiceQuestLevelMap, ServiceQuestSourceMap } from '@/config/global.js'
import { formatTime, clone } from '@/util/index'
import CustomerSelect from '@/components/select/customer_select'
import UserSelect from '@/components/select/user_select'
import DealerSelect from '@/components/select/dealer_select'
import ItemCategorySelect from '@/components/select/item_category_select'
import ServiceQuestFlowSelect from '@/components/select/service_quest_flow_select'
import FlowStepSelector from './flow_step_selector'

import {
  ServiceQuestStatusMap,
  ServiceQuestModeStatus,
  ServiceQuestCMMCategoryTextMap,
  ServiceQuestCategory,
  DeviceApplicationOptions,
} from '../../config/global'
import { timeWait, isMobile, scrollToTop } from '../../util'
import store from '@/store/store'

const ModeStatusOptions = [
  { val: 0, label: '不限' },
  { val: 2, label: 'STC接收（STC）' },
  { val: 3, label: '开始检查（STC）' },
  { val: 4, label: '完成报告并上传（STC）' },
  { val: 5, label: '质保判定（STC）' },
  { val: 101, label: '销售处理（STC）' },
  { val: 6, label: '定货（STC）' },
  { val: 7, label: '备件齐（STC）' },
  { val: 8, label: '维修完成发货（STC）' },
  { val: 111, label: '方案确认（客户现场维修）' },
  { val: 112, label: '备件齐完成派工（客户现场维修）' },
  { val: 116, label: '工程师上门（客户现场维修）' },
  { val: 113, label: '质保判定（客户现场维修）' },
  { val: 114, label: '销售处理（客户现场维修）' },
  { val: 115, label: '完成服务（客户现场维修）' },
  { val: 9, label: '备件齐完成派工（FS）' },
  { val: 10, label: '质保判定（FS）' },
  { val: 14, label: '销售处理（FS）' },
  { val: 11, label: '完成服务（FS）' },
  { val: 20, label: '完成服务（销售跟进）' },
  { val: 30, label: '发出（海外维修/检查）' },
  { val: 32, label: '返回判定（海外维修/检查）' },
  { val: 34, label: '发回客户（海外维修/检查）' },
  { val: 55, label: '关单（本地处理）' },
  { val: 62, label: 'CDC处理（转CDC）' },
  { val: 65, label: '关单（转CDC）' },
  { val: 72, label: '备件齐完成派工（FS收费维修）' },
  { val: 74, label: '完成服务（FS收费维修）' },
  { val: 82, label: 'STC接收（STC收费维修）' },
  { val: 84, label: '定货（STC收费维修）' },
  { val: 86, label: '备件齐（STC收费维修）' },
  { val: 88, label: '维修完成发货（STC收费维修）' },
  { val: 91, label: '发出（海外收费维修）' },
  { val: 93, label: '海外返回（海外收费维修）' },
  { val: 95, label: '发回客户（海外收费维修）' },
  { val: 130, label: 'PC接收（返回PC）' },
  { val: 131, label: '完成报告并上传（返回PC）' },
  { val: 132, label: '维修完成发货（返回PC）' },
]

const StatusOptions = [
  { val: 0, label: '不限' },
  { val: 1, label: '待评估' },
  { val: 2, label: '进行中' },
  { val: 3, label: '已关闭' },
  // { val: 4, label: '挂起' },
  { val: 100, label: '已完成' },
]

const OrderOptions = [
  { val: 'length(number) desc,number desc', label: 'NCR倒序' },
  {
    val: 'length(service_order_number) desc,service_order_number desc',
    label: 'ServiceOrder倒序',
  },
  { val: 'director_id desc', label: '负责人排序' },
  { val: 'total_time desc', label: '总用时倒序' },
  { val: 'last_step_completed_at asc', label: '等待时间倒序' },
]

export default {
  name: 'service_quest_list',
  components: {
    ServiceQuestFormer,
    CustomerSelect,
    UserSelect,
    DealerSelect,
    ItemCategorySelect,
    ServiceQuestFlowSelect,
    FlowStepSelector,
  },
  props: {
    param: Object,
    canNew: {
      type: Boolean,
      default: false,
    },
    category: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      DeviceApplicationOptions,
      cmm_categories: [],
      filterShow: false,
      isMobile,
      scrollToTop,
      modeStatusOptions: ModeStatusOptions,
      statusOptions: StatusOptions,
      OrderOptions,
      isadealer: store.getters.userInfo.dealer_id > 0,
      serviceQuests: [],
      formatTime,
      timeWait,
      ServiceQuestLevelMap,
      ServiceQuestStatusMap,
      ServiceQuestModeStatus,
      loading: false,
      addServiceQuestFormVisible: false,
      serviceQuestForm: {
        customer_id: 0,
        dealer_id: 0,
        customer_contact_id: 0,
        quest_dealer_contact_id: 0,
        // contact_name: null,
        // contact_mobile: null,
        customer_device_id: null,
        desc: '',
        level: 0,
        flow_id: 0,
      },
      total: 0,
      filter: {
        number: null,
        service_order_number: null,
        problem: '',
        filter_dealer_id: null,
        customer_id: null,
        customer_device_id: null,
        item_category_id: null,
        machine_type: null,
        serial_number: null,
        statuses: [1, 2, 4],
        factory: '',
        in_repair_scope: null,
        give_insurance: null,
        hs2_status: 0,
        logistics_status: 0,
        mode_status: null,
        mode: null,
        initiator: '',
        director_id: null,
        date: '',
        level: null,
        page: 1,
        size: 20,
        over_time: null,
        service_quest_flow_id: null,
        step_ids: [],
        order_arr: [],
        industries: [],
      },
    }
  },
  watch: {
    'filter.page': function () {
      this.requestServiceQuest()
    },
  },
  created() {
    if (this.$route.query.filter) {
      this.filter = this.filterDecode(this.$route.query.filter)
    }

    // let statuses = [1, 2, 4]
    // let queryStatuses = this.$route.query.statuses

    // if (queryStatuses) {
    //   if (typeof queryStatuses == 'object') {
    //     statuses = this.$route.query.statuses.map((item) => {
    //       return parseInt(item)
    //     })
    //   } else {
    //     statuses = [parseInt(statuses)]
    //   }
    // }

    // this.filter = {
    //   number: this.$route.query.number || '',
    //   service_order_number: this.$route.query.service_order_number || '',
    //   page: parseInt(this.$route.query.page || 1),
    //   size: parseInt(this.$route.query.size || 20),
    //   customer_id: parseInt(this.$route.query.customer_id || 0),
    //   filter_dealer_id: parseInt(this.$route.query.filter_dealer_id || 0),
    //   customer_device_id: parseInt(this.$route.query.customer_device_id || 0),
    //   item_category_id: parseInt(this.$route.query.item_category_id || 0),
    //   level: parseInt(this.$route.query.level || 0),
    //   machine_type: this.$route.query.machine_type || '',
    //   serial_number: this.$route.query.serial_number || '',
    //   factory: this.$route.query.factory || '',
    //   in_repair_scope: parseInt(this.$route.query.in_repair_scope || 0),
    //   give_insurance: parseInt(this.$route.query.give_insurance || 0),
    //   mode_status: parseInt(this.$route.query.mode_status || 0),
    //   statuses: statuses,
    //   mode: parseInt(this.$route.query.mode || 0),
    //   initiator: this.$route.query.initiator || '',
    //   director_id: parseInt(this.$route.query.director_id || 0),
    //   date: this.$route.query.date || [],
    //   problem: this.$route.query.problem || '',
    // }
    this.requestServiceQuest()
    this.getCategories()
  },

  computed: {
    problemOptions() {
      var arr = []
      var fatherCate = {}

      for (const key in ServiceQuestCMMCategoryTextMap) {
        fatherCate[ServiceQuestCMMCategoryTextMap[key]] = key
      }

      for (const key in ServiceQuestCategory) {
        let subArr = ServiceQuestCategory[key]

        if (subArr.length == 0) {
          let item = fatherCate[key]
          arr.push({
            label: item,
            value: item,
          })
        } else {
          subArr.map((item, index) => {
            item += `（${fatherCate[key]}）`
            arr.push({
              label: item,
              value: item,
            })
          })
        }
      }
      return arr
    },
    queryData() {
      let query = Object.assign({}, this.filter, this.param)
      query.initiator = String(query.initiator || '')
      if (query.date && query.date.length == 2) {
        query.start_date = query.date[0] || ''
        query.end_date = query.date[1] || ''
      }
      // if (!this.isFilterStatuses) {
      //   query.statuses = []
      // }
      query.category = this.category
      return query
    },
    isFilterStatuses() {
      return this.category == 1 && Object.keys(this.param).length == 0
    },
  },
  methods: {
    statusChange() {
      if (this.filter.statuses.length > 1) {
        let last = this.filter.statuses[this.filter.statuses.length - 1]
        if (last == 0) {
          this.filter.statuses = [0]
        } else {
          this.filter.statuses = this.filter.statuses.filter(
            (item) => item != 0,
          )
        }
      }
    },
    async requestServiceQuest() {
      this.$router.replace({
        query: this.filterEncode(this.filter),
      })

      this.loading = true
      let query = Object.assign({}, this.filter, this.param)
      query.initiator = String(query.initiator || '')
      query.page = query.page - 1

      if (query.date && query.date.length == 2) {
        query.start_date = query.date[0] || ''
        query.end_date = query.date[1] || ''
      }

      query.category = this.category

      // if (!this.isFilterStatuses) {
      //   query.statuses = []
      // }

      let res = await serviceQuestList(query)
      if (res.code == 0) {
        this.serviceQuests = res.data.list || []
        this.total = res.data.total
      }
      this.loading = false
    },
    async getCategories() {
      let res = await ccmCategoryList()
      this.cmm_categories = res.data.list.map((item) => {
        let arr = item.whole_name.split(',')
        return arr.length > 1 ? arr.join('（') + '）' : arr.join('')
      })
    },
    createdServiceQuest(sq) {
      this.$router.push(`${this.$route.path}/${sq.id}?origin=0`)
      // this.serviceQuests.unshift(sq)
    },
    reset() {
      this.filter = {
        number: null,
        service_order_number: null,
        problem: '',
        filter_dealer_id: null,
        customer_id: null,
        customer_device_id: null,
        item_category_id: null,
        machine_type: null,
        serial_number: null,
        statuses: [1, 2, 4],
        factory: '',
        in_repair_scope: null,
        give_insurance: null,
        hs2_status: 0,
        logistics_status: 0,
        mode_status: null,
        mode: null,
        initiator: '',
        director_id: null,
        date: '',
        level: null,
        page: 1,
        size: 20,
        over_time: null,
        service_quest_flow_id: null,
        step_ids: [],
        order_arr: [],
        industries: [],
      }
      this.requestServiceQuest()
    },
    startServiceQuestFormer() {
      this.serviceQuestForm = {
        customer_id: null,
        dealer_id: null,
        customer_contact_id: 0,
        quest_dealer_contact_id: 0,
        // contact_name: null,
        // contact_mobile: null,
        customer_device_id: null,
        device_running_time: 0,
        device_application: [],
        desc: '',
        desc_imgs: [],
        desc_videos: [],
        level: 1,
        flow_id: null,
        category: this.category,
        sub_category: null,
        cmm_category: null,
        dealer: { id: 0 },
      }
      this.addServiceQuestFormVisible = true
    },
  },
}
</script>

<style scoped>
/deep/.el-divider--horizontal {
  margin: 5px 0 15px 0;
}

/deep/.mul-long .el-input {
  width: 540px;
}

.value-status-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #c0c4cc;
}

.value-status-dot.has-value {
  background-color: #67c23a;
}
</style>
